module.exports = "<div *ngIf=\"relatedPanel.icon\" ngClass=\"tab-icon\">\n    <igx-icon fontSet=\"material\" [name]=\"relatedPanel.icon\"></igx-icon>\n    <igx-badge [value]=\"_changesCount\" [hidden]=\"_changesCount == 0\"></igx-badge>\n</div>\n<div *ngIf=\"relatedPanel.label\" ngClass=\"tab-label\">{{relatedPanel.label}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/tabbar/tab.component.html
// module id = 86
// module chunks = 0 1